import { SxProps } from '@mui/material'

export const sectionHeadlineSx: SxProps = {
  padding: { xs: '4px 24px', md: '10px 36px' }
}

export const sectionPaperSx: SxProps = {
  borderRadius: '26px',
  border: 'none'
}

export const sectionLoadingSx: SxProps = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
}

export const sectionArticleSxSmall: SxProps = {
  padding: {
    xs: '0px 24px',
    md: '72px 120px'
  }
}

export const sectionArticleSxLarge: SxProps = {
  padding: {
    xs: '30px 24px',
    md: '30px 50px',
    lg: '48px 96px'
  }
}

export const sectionTitleContainerSxSmall: SxProps = {
  display: 'flex',
  justifyContent: 'center'
}

export const sectionTitleContainerSxLarge: SxProps = {
  display: 'flex',
  justifyContent: 'flex-start'
}

export const sectionDescriptionSxSmall: SxProps = {
  '&:not(:first-of-type)': { marginTop: '40px' }
}

export const sectionDescriptionSxLarge: SxProps = {
  '&:not(:first-of-type)': { marginTop: '20px' }
}

export const sectionContentSxSmall: SxProps = {
  '&:not(:first-of-type)': { marginTop: '48px' },
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center'
}

export const sectionContentSxLarge: SxProps = {
  '&:not(:first-of-type)': { marginTop: '48px' },
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'inherit'
}

export const sectionActionsDesktopSx = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '24px',
  '&:not(:first-of-type)': { marginTop: '50px' }
}

export const sectionActionsMobileSx = {
  display: 'flex',
  flexDirection: 'column-reverse',
  alignItems: 'center',
  justifyContent: 'center',
  marginTop: '20px',
  '& > *:not(:first-child)': { marginBottom: '12px' }
}
